import script from "./WeeklyHoursSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyHoursSection.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyHoursSection.vue?vue&type=style&index=0&id=6f7b6039&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7b6039"]])

export default __exports__